export function withLoading<T extends { loading: boolean }, F>(self: T, p: Promise<F>, showLoading = true): Promise<F> {
    if (!showLoading) {
        return p
    }
    self.loading = true
    return p.finally(() => {
        self.loading = false
    })
}
